import { FC } from 'react';

import { TabsWorkspace } from './TabsWorkspace';
import type { TabsWorkspaceOwnProps } from './TabsWorkspace.connect';
import { connectTabsWorkspace } from './TabsWorkspace.connect';

export const Component: FC<TabsWorkspaceOwnProps> = connectTabsWorkspace(TabsWorkspace);

export const ConnectedTabsWorkspace: FC<TabsWorkspaceOwnProps> = ({ workspace, ...otherProps }) => (
  <Component key={workspace} workspace={workspace} {...otherProps} />
);

ConnectedTabsWorkspace.displayName = 'ConnectedTabsWorkspace';
